var BROWSE_REFINEMENT_KEYS, BrowseApplication, BrowseContentView, BrowseHeaderTitleHelper, BrowseParsedParamsHelper, BrowseUpdateAppUrlHelper, BrowseUrlContructionHelper, DealsMmSearch, DealsPaginationEvents, PaginatedDealsBuilder, RefinementUI, SortToggleApplication, SpinnerGroup, ToolTipDelayView,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

BrowseContentView = require('./views/content');

BrowseHeaderTitleHelper = require('./helpers/header_title');

BrowseUpdateAppUrlHelper = require('./helpers/update_app_url');

BrowseUrlContructionHelper = require('./helpers/url_construction');

BrowseParsedParamsHelper = require('./helpers/parsed_params');

DealsMmSearch = require('../../deals/frontend/mm_search');

DealsPaginationEvents = require('../../deals/frontend/pagination_events');

PaginatedDealsBuilder = require('../../deals/frontend/helpers/paginated_deals_builder');

RefinementUI = require('grpn-refinement-ui/lib/frontend/application');

SortToggleApplication = require('../../grpn-sorts/frontend/application');

SpinnerGroup = require('./helpers/spinner_group');

ToolTipDelayView = require('./views/tool_tip_delay');

BROWSE_REFINEMENT_KEYS = ['category', 'category2', 'interest', 'minPrice', 'maxPrice', 'price', 'query'];

module.exports = BrowseApplication = (function() {
  var browseContentViewInstance, fetchAndRenderDeals, initAppWithoutRefinementUI, initNewRatingSortMessage, initRefinementUI, initSortsApp, refinementUIAppInstance, relocateInAppMessages, updatePageContent;

  refinementUIAppInstance = browseContentViewInstance = void 0;

  function BrowseApplication(arg) {
    this.isLeftBarVisible = arg.isLeftBarVisible, this.isOnNoDealsPage = arg.isOnNoDealsPage, this.goodsBrowsePageLayoutValue = arg.goodsBrowsePageLayoutValue, this.inNewHomepage = arg.inNewHomepage, this.carouselConfig = arg.carouselConfig, this.homeWidgetPreview = arg.homeWidgetPreview, this.showFreeShippingModal = arg.showFreeShippingModal, this.selectedCategory = arg.selectedCategory, this.isSeoEnabled = arg.isSeoEnabled, this.isVanityUrl = arg.isVanityUrl, this.collection = arg.collection, this.inRAPI = arg.inRAPI, this.useNewGAPIConnector = arg.useNewGAPIConnector;
    this.renderContent = bind(this.renderContent, this);
    this.resetRefinementUi = bind(this.resetRefinementUi, this);
    this.assignUrlBuilder();
  }

  BrowseApplication.prototype.assignUrlBuilder = function() {
    return this.constructUrl = (function() {
      switch (false) {
        case !this.collection:
          return BrowseUrlContructionHelper.getConstructCollectionById(this.collection.id, this.collection.type);
        case !this.isSeoEnabled:
          return BrowseUrlContructionHelper.constructV3;
        default:
          return BrowseUrlContructionHelper.constructV1;
      }
    }).call(this);
  };

  BrowseApplication.prototype.isMmHome = function() {
    var queryKeys;
    queryKeys = _.keys(Groupon.Utils.unparam());
    return this.goodsBrowsePageLayoutValue === 'mmhome' && !_.intersection(queryKeys, BROWSE_REFINEMENT_KEYS).length && !this.collection && !this.isVanityUrl;
  };

  BrowseApplication.prototype.startApp = function() {
    if (this.isMmHome()) {
      return this.renderMmHomeDeals(new DealsMmSearch({
        inNewHomepage: this.inNewHomepage,
        carouselConfig: this.carouselConfig,
        homeWidgetPreview: this.homeWidgetPreview,
        showFreeShippingModal: this.showFreeShippingModal
      }));
    } else {
      if (this.isLeftBarVisible) {
        initRefinementUI(this.constructUrl);
      } else {
        initAppWithoutRefinementUI();
      }
      relocateInAppMessages();
      return initSortsApp();
    }
  };

  BrowseApplication.prototype.resetRefinementUi = function() {
    if (refinementUIAppInstance != null) {
      refinementUIAppInstance.updateRefinements(Groupon.refinementUiPageData, {
        queue: true
      });
      return BrowseUpdateAppUrlHelper.updateFromRefinements(refinementUIAppInstance.selectedRefinements, this.constructUrl);
    }
  };

  BrowseApplication.prototype.renderContent = function(options) {
    return browseContentViewInstance != null ? browseContentViewInstance.render(options) : void 0;
  };

  initAppWithoutRefinementUI = function() {
    return browseContentViewInstance = new BrowseContentView({
      isContentRendered: true
    });
  };

  initRefinementUI = function(constructionLibrary) {
    var categoryAttributeWhitelistRemoval, categoryAttributesEnabled, enabledFacets, facetFilterKeys, getEnabledFacets, getParsedParams, ref, ref1, ref2, ref3, refinementUiOptions, updateFromRefinements;
    updateFromRefinements = BrowseUpdateAppUrlHelper.updateFromRefinements, getEnabledFacets = BrowseUpdateAppUrlHelper.getEnabledFacets, getParsedParams = BrowseUpdateAppUrlHelper.getParsedParams;
    facetFilterKeys = (ref = Groupon.facetFilterKeys) != null ? ref : [];
    categoryAttributesEnabled = (ref1 = Groupon.categoryAttributesEnabled) != null ? ref1 : {};
    categoryAttributeWhitelistRemoval = (ref2 = Groupon.categoryAttributeWhitelistRemoval) != null ? ref2 : false;
    refinementUiOptions = (ref3 = Groupon.refinementUiOptions) != null ? ref3 : {};
    refinementUiOptions.container = '#refinement-ui';
    refinementUIAppInstance = new RefinementUI(Groupon.refinementUiPageData, refinementUiOptions);
    BrowseHeaderTitleHelper.updateHeaderTitle($('.page-header .title'), Groupon.refinementUiPageData, Groupon.seoMetaHash);
    refinementUIAppInstance.events.on('refinementsUpdated', function(selectedRefinements, selectedId) {
      var _filterSelectedRefinements, l1, l2, l3, l4, ref4, ref5, ref6;
      Groupon.browseApp.lastUpdatedRefinementId = selectedId;
      if (!categoryAttributeWhitelistRemoval) {
        _filterSelectedRefinements = function(Lm, categoryName) {
          var LmWhitelist, facetName, i, len, ref4, results, whitelist;
          if (!(LmWhitelist = categoryAttributesEnabled[Lm])) {
            return;
          }
          whitelist = (ref4 = LmWhitelist[categoryName]) != null ? ref4 : [];
          results = [];
          for (i = 0, len = facetFilterKeys.length; i < len; i++) {
            facetName = facetFilterKeys[i];
            if (indexOf.call(whitelist, facetName) < 0) {
              results.push(delete selectedRefinements[facetName]);
            } else {
              results.push(void 0);
            }
          }
          return results;
        };
        if (!(l1 = selectedRefinements.category)) {

        } else if (!(l2 = (ref4 = l1.selectedValues) != null ? ref4[0] : void 0)) {
          _filterSelectedRefinements('L2', 'all');
        } else if (!(l3 = (ref5 = l2.selectedValues) != null ? ref5[0] : void 0)) {
          _filterSelectedRefinements('L2', l2.name);
        } else if (!(l4 = (ref6 = l3.selectedValues) != null ? ref6[0] : void 0)) {
          _filterSelectedRefinements('L3', l3.name);
        }
      }
      updateFromRefinements(selectedRefinements, constructionLibrary);
      return updatePageContent();
    });
    browseContentViewInstance = new BrowseContentView({
      isContentRendered: true,
      refinementUIAppInstance: refinementUIAppInstance
    });
    if (refinementUIAppInstance.selectedRefinements) {
      enabledFacets = getEnabledFacets(refinementUIAppInstance.selectedRefinements);
      return BrowseParsedParamsHelper.setParsedParams(getParsedParams(enabledFacets));
    }
  };

  updatePageContent = function() {
    fetchAndRenderDeals();
    return OptimizeSuite.treatAsNewPage(window.location.href);
  };

  initNewRatingSortMessage = function() {
    var ratingTooltipElem;
    if ((Cookie.get('goodsNewRatingSortMessage') === 'hide') || !Groupon.showSortByRatings || !(ratingTooltipElem = $('.rating-sort-tooltip-container')).length) {
      return;
    }
    ratingTooltipElem.fadeIn(200);
    return $('.rating-sort-tooltip-container .rating-sort-tooltip-close').one('click', function() {
      ratingTooltipElem.fadeOut(200);
      return Cookie.set('goodsNewRatingSortMessage', 'hide');
    });
  };

  initSortsApp = function(constructionLibrary) {
    return $(function() {
      var ref, ref1, sortsApp;
      sortsApp = SortToggleApplication;
      sortsApp.initialize();
      BrowseUpdateAppUrlHelper.updateFromSorts({
        sort: (ref = sortsApp.sortToggleView) != null ? (ref1 = ref.$el) != null ? ref1.val() : void 0 : void 0
      });
      sortsApp.on('change:sort', function(selectedRefinements) {
        BrowseUpdateAppUrlHelper.updateFromSorts(selectedRefinements);
        return fetchAndRenderDeals();
      });
      if (browseContentViewInstance != null) {
        browseContentViewInstance.setSortsApp(sortsApp);
      }
      return initNewRatingSortMessage();
    });
  };

  relocateInAppMessages = function() {
    return $(function() {
      var banner;
      banner = $('#in-app-messages').detach();
      banner.find('.hide-link').click(function() {
        return banner.slideUp();
      });
      return banner.appendTo('#inAppMessageBanner');
    });
  };

  fetchAndRenderDeals = function() {
    var paginatedBuilder;
    paginatedBuilder = new PaginatedDealsBuilder;
    if (browseContentViewInstance == null) {
      browseContentViewInstance = new BrowseContentView();
    }
    browseContentViewInstance.setDealsSearch(paginatedBuilder.search);
    browseContentViewInstance.render({
      paginatedDealsBuilder: paginatedBuilder
    });
    return paginatedBuilder.on('fetchSuccess', function(search) {
      var ref, refinementUiPageData, seoMetaHash;
      if (Groupon.refinementUiPageData) {
        ref = search.page, refinementUiPageData = ref.refinementUiPageData, seoMetaHash = ref.seoMetaHash;
        Groupon.refinementUiPageData = refinementUiPageData;
        if (seoMetaHash) {
          Groupon.seoMetaHash = seoMetaHash;
        }
        refinementUIAppInstance.updateRefinements(refinementUiPageData);
        BrowseHeaderTitleHelper.updateHeaderTitle($('.page-header .title'), refinementUiPageData, seoMetaHash);
      }
      return DealsPaginationEvents.trigger('newPage', search.page);
    });
  };

  BrowseApplication.prototype.renderMmHomeDeals = function(mmSearch) {
    this._startSpinner();
    mmSearch.on('error', (function(_this) {
      return function() {
        return _this._onDoneFetchingDeals(function() {});
      };
    })(this));
    return mmSearch.on('success', (function(_this) {
      return function(deals, dealIdList) {
        return _this._onDoneFetchingDeals(function() {
          return $(function() {
            $('#browse_deals_container').replaceWith(deals);
            return GIG.Tooltip.reloadBindings(document.body);
          });
        });
      };
    })(this));
  };

  BrowseApplication.prototype._onDoneFetchingDeals = function(renderContentCallback) {
    renderContentCallback();
    return this._stopSpinner();
  };

  BrowseApplication.prototype._stopSpinner = function() {
    return SpinnerGroup.stop('deal-space', {
      remove: true
    });
  };

  BrowseApplication.prototype._startSpinner = function() {
    return SpinnerGroup.start('deal-space', {
      parentElem: $('#deal-space'),
      css: {
        marginTop: '100px'
      },
      useV2: true
    });
  };

  return BrowseApplication;

})();

//# sourceMappingURL=data:application/json;base64,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
